import { HeaderCell } from '../../cells/holders/header-cell.component';
import { BodyCell } from '../../cells/holders/body-cell.component';
import { DomHolder } from '../../cells/holders/dom-holder.directive';
import { AbstractTable, ICol } from '../context/abstract/table.class';
import { ColCash } from './cash.class';
import { SortableArgs, Sortable } from '../../../utils/sorter.class';


export interface ColArgs<D extends object> {
   order: number;
   sortable: SortableArgs<D>;
   width: CssWidth;
   ctx: AbstractTable<D>;
}


export class Col<D extends object> implements DomHolder {
   readonly id: string;
   readonly title: () => string;
   readonly component: HeaderCell;
   readonly width: CssWidth;
   readonly cell: BodyCell<D>;
   readonly sortable: Sortable<D>;
   readonly isControlable: boolean;
   readonly dom: HTMLElement = null;
   readonly ctx: AbstractTable<D>;
   readonly defaults: ColCash;
   public order: number;
   public isVisible: boolean;
   public isPinned: boolean;

   
   constructor({ 
      id,
      title, 
      cell, 
      isVisible, 
      isPinned, 
      isControlable, 
      header: component,
   }: ICol<D>, {
      order,
      sortable,
      width,
      ctx,
   }: ColArgs<D>) {
      this.title = title;
      this.cell = cell;
      this.sortable = new Sortable(sortable);
      this.isVisible = isVisible;
      this.isControlable = isControlable;
      this.width = width;
      this.component = component;
      this.order = order;
      this.isPinned = isPinned;
      this.ctx = ctx;
      this.id = `${+order + +isVisible + +isPinned + +sortable.isActive} : ${id}`;
      this.defaults = this.toJson();
   }


   public toJson(): ColCash {
      return {
         id: this.id,
         order: this.order,
         isVisible: this.isVisible,
         sort: this.sortable.state,
         ...this.width,
      }
   }

}


export interface CssWidth {
   initialMinWidth: number;
   'width.%': number;
   'min-width.px': number;
   'max-width.px': number;
}
